'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var parseDuration = require('parse-duration');

var crypto = require('libp2p-crypto');

var errCode = require('err-code');

var fromString = require('uint8arrays/from-string');

var toString = require('uint8arrays/to-string');

var utils = require('../../utils.js');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var utils$1 = require('./utils.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var parseDuration__default = /*#__PURE__*/_interopDefaultLegacy(parseDuration);

var crypto__default = /*#__PURE__*/_interopDefaultLegacy(crypto);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var log = Object.assign(debug__default["default"]('ipfs:name:publish'), {
  error: debug__default["default"]('ipfs:name:publish:error')
});

function createPublish(_ref) {
  var ipns = _ref.ipns,
      repo = _ref.repo,
      codecs = _ref.codecs,
      peerId = _ref.peerId,
      isOnline = _ref.isOnline,
      keychain = _ref.keychain;

  var lookupKey = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(keyName) {
      var pem, privateKey;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(keyName === 'self')) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", peerId.privKey);

            case 2:
              _context.prev = 2;
              _context.next = 5;
              return keychain.exportKey(keyName, 'temp');

            case 5:
              pem = _context.sent;
              _context.next = 8;
              return crypto__default["default"].keys.import(pem, 'temp');

            case 8:
              privateKey = _context.sent;
              return _context.abrupt("return", privateKey);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](2);
              log.error(_context.t0);
              throw errCode__default["default"](_context.t0, 'ERR_CANNOT_GET_KEY');

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 12]]);
    }));

    return function lookupKey(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  function publish(_x2) {
    return _publish.apply(this, arguments);
  }

  function _publish() {
    _publish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(value) {
      var options,
          resolve,
          lifetime,
          key,
          pubLifetime,
          results,
          bytes,
          result,
          _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              resolve = !(options.resolve === false);
              lifetime = options.lifetime || '24h';
              key = options.key || 'self';

              if (isOnline()) {
                _context2.next = 6;
                break;
              }

              throw errCode__default["default"](new Error(utils.OFFLINE_ERROR), 'OFFLINE_ERROR');

            case 6:
              _context2.prev = 6;
              value = utils.normalizePath(value);
              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](6);
              log.error(_context2.t0);
              throw _context2.t0;

            case 14:
              pubLifetime = 0;
              _context2.prev = 15;
              pubLifetime = parseDuration__default["default"](lifetime) || 0;
              pubLifetime = parseFloat(pubLifetime.toFixed(6));
              _context2.next = 24;
              break;

            case 20:
              _context2.prev = 20;
              _context2.t1 = _context2["catch"](15);
              log.error(_context2.t1);
              throw _context2.t1;

            case 24:
              _context2.next = 26;
              return Promise.all([lookupKey(key), resolve ? utils$1.resolvePath({
                ipns: ipns,
                repo: repo,
                codecs: codecs
              }, value) : Promise.resolve()]);

            case 26:
              results = _context2.sent;
              bytes = fromString.fromString(value);
              _context2.next = 30;
              return ipns.publish(results[0], bytes, pubLifetime);

            case 30:
              result = _context2.sent;
              return _context2.abrupt("return", {
                name: result.name,
                value: toString.toString(result.value)
              });

            case 32:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 10], [15, 20]]);
    }));
    return _publish.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(publish);
}

exports.createPublish = createPublish;